import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: { background: "#161F33", border: "1px solid rgba(255,255,255,0.1)", color: "#F8FAFC", fontFamily: "'Plus Jakarta Sans', sans-serif" },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
